import { useEffect, useState } from 'react';
import { apiFetch } from '../api/apiClient';
import { toSlug } from '../util/strings';

/** Missing flags stay visible. An explicit false hides that characteristic. */
export function isMetricEnabled(flags, key) {
  if (!flags || flags[key] == null) return true;
  return flags[key] !== false;
}

/** Storage charts plot charge and discharge together. */
export function batteryPowerEnabled(flags) {
  return isMetricEnabled(flags, 'battery_charge') || isMetricEnabled(flags, 'battery_discharge');
}

export function useSiteMetricFlags(siteName) {
  const [flags, setFlags] = useState(null);
  const slug = toSlug(siteName) || '';

  useEffect(() => {
    if (!slug) {
      setFlags({});
      return undefined;
    }

    let cancelled = false;
    apiFetch(`/api/metrics/portfolio/${slug}/metric-flags`)
      .then((data) => {
        if (cancelled) return;
        const next = data?.flags;
        setFlags(next && typeof next === 'object' ? next : {});
      })
      .catch(() => {
        if (!cancelled) setFlags({});
      });

    return () => {
      cancelled = true;
    };
  }, [slug]);

  return flags;
}
